import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';
import {UserConnexionStyles} from '../../../User/components/Connexion/styles';
import {leagueMode} from '../LeagueInfo/components/Infos';

export const setDivisionMode = payload => {
  return (_dispatch, getState) => {
    fetch(getEndpoint('setDivisionMode', payload.divisionId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({mode: payload.mode}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          payload.onSuccess();
        }
      });
  };
};

const DivisionInfos = ({data, dispatch, refreshDivisionInfos}) => {
  if (!data) {
    return null;
  }
  return (
    <div style={UserConnexionStyles.container}>
      <SupportTitle title="division infos" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <TableRow label="id" value={data.id} />
          <TableRow label="name" value={data.name} />
          <TableRow label="mercatoTurn" value={data.mercatoState.turn} />
          <TableRow
            label="mercatoStartDate"
            value={data?.gameSettings?.mercatoStartDate}
          />
          {data.mercatoState.mercatoTurnDate && (
            <TableRow
              label="mercatoTurnStartedAt"
              value={data.mercatoState.mercatoTurnDate}
            />
          )}
          {data.mercatoState.nextMercatoTurn && (
            <TableRow
              label="nextMercatoTurnDate"
              value={data.mercatoState.nextMercatoTurn}
            />
          )}
          {data.liveState && data.liveState.liveAt && (
            <TableRow label="liveAt" value={data.liveState.liveAt} />
          )}
          <TableRow
            label="Mode"
            value={leagueMode[data?.gameSettings?.mode]}
            action={
              <Fragment>
                <i
                  style={{color: 'black'}}
                  onClick={() => {
                    if (data.gameSettings.mode === 1) {
                      dispatch(
                        setDivisionMode({
                          divisionId: data.id,
                          mode: 2,
                          onSuccess: refreshDivisionInfos,
                        }),
                      );
                    }
                  }}
                  className={classNames('fa fa-2x', {
                    'fa-toggle-on': data.gameSettings.mode === 2,
                    'fa-toggle-off': data.gameSettings.mode === 1,
                  })}
                />
                <p>Achtiver le mode expert</p>
              </Fragment>
            }
          />
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(DivisionInfos);



// WEBPACK FOOTER //
// ./src/pages/Support/League/Widgets/DivisionInfos/index.js